var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69999 11.6565L1.73361 10.6902C1.47326 10.4298 1.47326 10.0077 1.73361 9.74735L4.09063 7.39032L5.03344 8.33313C5.29379 8.59348 5.7159 8.59348 5.97625 8.33313C6.2366 8.07278 6.2366 7.65067 5.97625 7.39032L5.03344 6.44751L9.74749 1.73347C10.0078 1.47312 10.4299 1.47312 10.6903 1.73347L11.6567 2.69985C11.2279 3.34698 11.2987 4.22744 11.8688 4.7976C12.439 5.36775 13.3194 5.43846 13.9666 5.00973L14.9329 5.97611C15.1933 6.23646 15.1933 6.65857 14.9329 6.91892L10.2189 11.633L9.27608 10.6902C9.01573 10.4298 8.59362 10.4298 8.33327 10.6902C8.07293 10.9505 8.07293 11.3726 8.33327 11.633L9.27608 12.5758L6.91906 14.9328C6.65871 15.1931 6.2366 15.1931 5.97625 14.9328L5.00987 13.9664C5.4386 13.3193 5.36789 12.4388 4.79774 11.8687C4.22759 11.2985 3.34712 11.2278 2.69999 11.6565ZM6.44766 8.80454C6.18731 9.06489 6.18731 9.487 6.44766 9.74735L6.91906 10.2188C7.17941 10.4791 7.60152 10.4791 7.86187 10.2188C8.12222 9.9584 8.12222 9.53629 7.86187 9.27594L7.39047 8.80454C7.13012 8.54419 6.70801 8.54419 6.44766 8.80454Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.c8e1d715baf11efa5c017caae6e1f7dd.svg";
export { ForwardRef as ReactComponent };